import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productDetailsImageCarouselStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageCarousel";
import getColor from "@insite/mobius/utilities/getColor";

import { css } from "styled-components";

productDetailsImageCarouselStyles.imageCarousel = mergeToNew(productDetailsImageCarouselStyles.imageCarousel, {
    mainContainer: {
        css: css`
            margin-top: 18px;
        `,
    },
    carouselSlide: {
        css: css`
            flex: 0 0 ${100 / 4}%;
            padding: 0;
            position: relative;
            > div {
                padding-top: 0;
                button {
                    width: 100%;
                }
            }
        `,
    },
    image: {
        css: css`
            max-height: 80px;
            height: 80px;
            width: 100%;

            padding: 5px;
            border-radius: 8px;
            border: 1px solid ${getColor("common.border")};
            > img {
                height: auto;
                width: auto;
                max-height: 100%;
                max-width: 100%;
            }
        `,
    },
    selectedImage: {
        css: css`
            max-height: 80px;
            height: 80px;
            width: 100%;
            padding: 5px;
            border-radius: 8px;
            border: 2px solid ${getColor("common.accent")};
            > img {
                height: auto;
                width: auto;
                max-height: 100%;
                max-width: 100%;
            }
        `,
    },
});
